import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allFeatureTexture } from '../../../../Actions/feature';
import { paramsOfTextureAction } from '../../../../Actions/paramsOfTextureAction';

const TextureSidebar = ({txtureee}) => {
    const picState = useSelector(state => state.picture);
    const dispatch = useDispatch();

    return ( 
        <Fragment>
            <div className='texture-container-sidebar py-3 w-100'>
                {txtureee.map(x => (
                    <div key={x.object_id} className='texture-element-sidebar' onClick={() =>{
                        dispatch(allFeatureTexture({featur_value:x.featur_value,translate:x.translate}))
                        dispatch(paramsOfTextureAction(x.object_id,x.procode))
                    }}>
                        <article>
                            <img src={x.ticon} alt={x.name} className="img-texture-sidebar"/>
                            <p className='p-2 texture-caption-sidebar'>
                                {x.name}
                            </p>
                        </article>
                        <p className={picState.object_id === x.object_id ? "check-texture d-block" : "d-none"}><i class="fa fa-check"></i></p>
                    </div>
                ))}
            </div>
        </Fragment>
     );
}
 
export default TextureSidebar;